import React, { Component } from 'react';

class Page404 extends Component {
    state = {  } 
    render() { 
        return (<h1>Page not found</h1>);
    }
}
 
export default Page404;